import {
  Empty,
  EmptyContent,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@aircall/ds";

import EvaluationEmptyViewImage from "@/assets/images/no_evaluation.svg?react";

import { EvaluationEmptyStateProps } from ".";
import { useTracking } from "./EvaluationEmptyState.hooks";

export function EvaluationEmptyState({
  title,
  children,
}: EvaluationEmptyStateProps) {
  useTracking();

  return (
    <Empty className="gap-10" data-test="empty-evaluation-state-section">
      <EmptyMedia className="mb-0 w-full max-w-[500px] md:max-w-[400px] lg:max-w-[500px]">
        <EvaluationEmptyViewImage />
      </EmptyMedia>
      <EmptyHeader>
        <EmptyTitle className="text-base font-normal">{title}</EmptyTitle>
      </EmptyHeader>
      {children ? <EmptyContent>{children}</EmptyContent> : null}
    </Empty>
  );
}
